module.exports = __webpack_public_path__ + "img/premios.b2e985ee.png";